import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const PersonaService = {
  getPersonaMasterData: async () => {
    const response = await api.get(API_ENDPOINTS.PERSONA.GETPERSONAMASTERDATA);
    return response;
  },

  createPersona: async (data) => {
    const response = await api.post(API_ENDPOINTS.PERSONA.CREATEPERSONA, data);
    return response;
  },

  updatePersona: async (id, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PERSONA.UPDATEPERSONA, {
      id,
    });
    const response = await api.put(endpoint, data);
    return response;
  },

  listAllPersonas: async (pageIndex, pageSize) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PERSONA.LISTALLPERSONAS, {
      page: pageIndex,
      pageSize,
    });
    const response = await api.get(endpoint);
    return response;
  },

  listPersonaByCustomerType: async (ctype) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.PERSONA.LISTPERSONACBYCUSTOMER,
      {
        ctype,
      }
    );
    const response = await api.get(endpoint);
    return response;
  },

  getPersonaInfo: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PERSONA.GETPERSONAINFO, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
};
